import { Component, createRef } from 'react';
import { Box, Button, Typography, Chip, CircularProgress, TextField, Stack, FormControl, InputLabel, Select, MenuItem, List, ListItem, ListItemButton, ListItemText, Divider, Dialog, DialogContent, DialogActions, DialogTitle, Tooltip } from '@mui/material';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { getCachevalue, localGetItem } from '../../../../Utility/Services/CacheProviderService';
import { Colors } from '../../../../Styles/Colors';
import Loader from '../../../../Components/Loader';
import { withTranslation } from 'react-i18next';
import { AddNewListItemPop, CommonPatientDetails, CommonPopUp, ConfirmPopup } from '../../../../Components/Common Components/CommonComponents';
import { ImagePaths } from '../../../../Utility/ImagePaths';

const defaultTxt = {
    "blocks": [{
        "key": "1",
        "text": "Dear Dr,\n\nThis is with reference To [patientName], [uhid] [age] has diagnosed with [eye_problem]. We noticed that He / She needs [surgery] surgery to be undergone. Kindly evaluate Him / Her regarding the same.\n\nRegards,\n[clinic_doctor]",
        "type": "unstyled",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [],
        "data": {}
    }],
    "entityMap": {}
}

const ITEM_HEIGHT = 80;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: '15vw',
    },
  },
};

let currentDate = new Date();

let day = currentDate.getDate();
let month = currentDate.getMonth() + 1;
let year = currentDate.getFullYear();

let formattedDate = `${day.toString().padStart(2, '0')}-${month.toString().padStart(2, '0')}-${year}`;

class DocRefferalNotesCommon extends Component {
    constructor(props) {
        super(props)
        this.state = {
            referral_id: "",
            refferalText: JSON.stringify(defaultTxt),
            dynamicValues: {
                patientName: "",
                uhid: "",
                age: "",
                eye_problem: "",
                surgery: ""
            },
            patientDetails: {},
            clinicId: '',
            appointmentId: '',
            patientId: '',
            doctorData: [],
            doctor_details: {
                id: "",
                doctor_name: "",
                qualifications: "",
                designation: "",
                clinic_name: "",
                city_name: "",
                country: "",
                mobile_number: "",
                email: "",
                clinics_city:''
            },
            eye_problem_data: [],
            eye_problem: {},
            eye_type_data: ["Left Eye", "Right Eye", "Both Eyes"],
            eye_type: "",
            systemic_illness_data: [],
            systemic_illness: {},
            surgery_data: [],
            surgery: {},
            is_add_doctor: false,
            is_add_eye_pbrlm: false,
            is_add_illness: false,
            is_add_surgery: false,
            isDoctorLoad: false,
            isLoader: false,
            isSaveSuccess: false,
            DrName: "",
            doctor_content: "",
            isDoctorContentNew: true,
            deleteItem : "",
            selectedItem: null,
            selectedEyeItem: null,
            selectedSurItem: null,
            edittempName: false,
            selectTemplate: '',
            templateList: [],
            isTempAdd: false,
            addLayoutName: '',
            tempContent: '',
            selectedID: null,
            deleteTemp: false,
            selecDelID: null,
            isDefault: false,
        }
        this.boxRef = createRef();
    }

    componentDidMount() {
        let clinicId = getCachevalue('SelectedDoctorClinic')
        let appointmentId = JSON.parse(getCachevalue('DoctorPatientData'))
        let ServiceType = localGetItem("loggedInUserInfo")
        let myUser = JSON.parse(ServiceType)
        let states = this.state
        states["dynamicValues"]["clinic_doctor"] = myUser?.doctor_name
        if (this.boxRef.current) {
            this.boxRef.current.innerHTML = this.state.doctor_content;
        }
        this.setState({
            clinicId: clinicId,
            appointmentId: appointmentId?.appointment_id,
            patientId: appointmentId?.patient_id,
            doctorId: appointmentId?.doctor_id,
            DrName: myUser?.doctor_name,
            patientDetails: appointmentId
        }, () => {
            this.getReferralNotesData()
            this.getDoctorListData()
            this.getPatientDetailData()
            this.getDoctorTemplate(true)
            this.getTempData()
        })
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message,
            disableBtn: false
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message,
            disableBtn: false
        })
    }

    LoaderFunction = (key, flag) => {
        let states = this.state;
        states[key] = flag;
        this.setState({
            states
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    getPatientDetailData = () => {
        let states = this.state
        try {
            RestAPIService.getAll(Serviceurls.DOC_PATIENT_DETAIL_GET + '?patient_id=' + this.state.patientId)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.setState({
                            patientDetails: {...this.state.patientDetails, ...response?.data?.data}
                        }, () => {
                            states["dynamicValues"]["patientName"] = (response?.data?.data?.first_name) + (response?.data?.data?.last_name ? response?.data?.data?.last_name : "")
                            states["dynamicValues"]["uhid"] = response?.data?.data?.patient_account_number
                            states["dynamicValues"]["age"] = response?.data?.data?.patient_age_str
                            this.setState({
                                states
                            }, () => {
                                this.getDoctorTemplate()
                            })
                        })

                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    getDoctorTemplate = (isFirstHit = false) => {
        try {
            let states = this.state
            RestAPIService.getAll(Serviceurls.DOC_OPT_REFERRAL_POST)
                .then((response) => {
                    if (response?.data?.status == "success") {
                        let referaldoctornotes = response.data.data
                        let result = referaldoctornotes.filter((item) => item.patient_id === this.state.patientId)
                        this.setState({ resultValue: result[result?.length - 1] })
                        if (this.state.patientDetails.gender == "m") {
                            this.state.patientDetails["genderType"] = "He"
                            this.setState({ states })
                        } else if (this.state.patientDetails.gender == "f") {
                            this.state.patientDetails["genderType"] = "She"
                            this.setState({ states })
                        }
                        this.setState({
                            doctor_content: result[result.length - 1]?.doctor_notes ? result[result.length - 1]?.doctor_notes : `Dear Dr ${this.state.doctor_details?.doctor_name ? this.state.doctor_details?.doctor_name : ""},\n\nThis is with reference To  ${this.state?.patientDetails?.first_name} ${this.state?.patientDetails?.last_name ? this.state?.patientDetails?.last_name : ""}, ${`(${this.state?.patientDetails?.patient_account_number})`} ${this.state?.patientDetails?.patient_age_str} has diagnosed with <b>${(Object.keys(this.state?.eye_problem).length > 0 ? this.state?.eye_problem?.eye_problem_name : "_____")}</b>. We noticed that ${this.state.patientDetails.gender ? this.state.patientDetails.gender === 'm' ? "He" : "She" : "He / She"} needs <b>${Object.keys(this.state?.surgery).length > 0 ? this.state?.surgery?.surgery_name : "_____"}</b> surgery to be undergone. Kindly evaluate ${this.state.patientDetails.gender ? this.state.patientDetails.gender == "m" ? "Him" : "Her" : "Him / Her"} regarding the same.\n\nRegards,\nDr ${this.state?.DrName}`
                        }, () => {
                            if (this.boxRef.current) {
                                this.boxRef.current.innerHTML = this.state.doctor_content;
                            }
                            if (isFirstHit) {
                                this.setState({
                                    isDoctorContentNew: result[result.length - 1]?.doctor_notes ? false : true,
                                    referral_id: result[result.length - 1]?.id ? result[result.length - 1]?.id : "",
                                    doctor_details: {
                                        doctor_name: result[result.length - 1]?.referral_doctor_name ? result[result.length - 1]?.referral_doctor_name : "",
                                        qualifications: result[result.length - 1]?.referral_qualifications ? result[result.length - 1]?.referral_qualifications : "",
                                        designation: result[result.length - 1]?.referral_designation ? result[result.length - 1]?.referral_designation : "",
                                        clinic_name: result[result.length - 1]?.referral_clinic_name ? result[result.length - 1]?.referral_clinic_name : "",
                                        city_name: result[result.length - 1]?.referral_city_name ? result[result.length - 1]?.referral_city_name : "",
                                        id: result[result.length - 1]?.referral_doctor ? result[result.length - 1]?.referral_doctor : null,
                                        clinics_city:result[result.length - 1]?.clinics_city ? result[result.length - 1]?.clinics_city : ''
                                    },
                                    eye_problem: (result[result.length - 1]?.eye_problem_id && result[result.length - 1]?.eye_problem_name) ?
                                        {
                                            eye_problem_id: result[result.length - 1]?.eye_problem_id,
                                            eye_problem_name: result[result.length - 1]?.eye_problem_name
                                        } : {},
                                    surgery: (result[result.length - 1]?.surgery_id && result[result.length - 1]?.surgery_name) ?
                                        {
                                            surgery_id: result[result.length - 1]?.surgery_id,
                                            surgery_name: result[result.length - 1]?.surgery_name
                                        } : {},
                                })
                            }
                        })

                        this.setState({
                            states
                        },()=>{
                            this.getTempData()
                        })
                    }

                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.LoaderFunction("isLoader", false);
                        this.errorMessage(error?.response?.data?.message)
                    } else {
                        this.LoaderFunction("isLoader", false);
                        this.errorMessage(error.message)
                    }
                })
        }
        catch (error) {
            this.errorMessage(error.message)
        }
    }

    getReferralNotesData = () => {
        try {
            this.LoaderFunction("isLoader", true);
            RestAPIService.getAll(Serviceurls.DOC_OPT_REFERRAL_GET)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.LoaderFunction("isLoader", false);
                        this.assignDetails(response?.data?.referral_note_items)
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.LoaderFunction("isLoader", false);
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.LoaderFunction("isLoader", false);
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    getDoctorListData = () => {
        try {
            this.LoaderFunction("isDoctorLoad", true);
            RestAPIService.getAll(Serviceurls.DOC_REFERRAL_DOCTOR_OPT)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.LoaderFunction("isDoctorLoad", false);
                        this.setState({
                            doctorData: response?.data?.doctor_profile?.length > 0 ? response.data?.doctor_profile : []
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.LoaderFunction("isDoctorLoad", false);
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.LoaderFunction("isDoctorLoad", false);
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    assignDetails = (referral_note_items, isAdd = false, title) => {
        if(isAdd){
            if(this.state.is_add_eye_pbrlm || title === "Eye Problem"){
                this.setState({
                    eye_problem_data: referral_note_items?.eye_problem_data?.length > 0 ? referral_note_items?.eye_problem_data : [],
                },()=>{
                    this.ClosePopUp();
                    this.setState({eye_problem: {}})
                })
            }else if(this.state.is_add_surgery || title === "Surgery"){
                this.setState({
                    surgery_data: referral_note_items?.surgery_data?.length > 0 ? referral_note_items?.surgery_data : [],
                },()=>{
                    this.ClosePopUp();
                    this.setState({surgery: {}})
                })
            }else if(this.state.is_add_illness || title === "Systemic Illness"){
                this.setState({
                    systemic_illness_data: referral_note_items?.systemic_illness_data?.length > 0 ? referral_note_items?.systemic_illness_data : [],
                },()=>{
                    this.ClosePopUp();
                    this.setState({systemic_illness: {}})
                })
            }
        }else{
            this.setState({
                eye_problem_data: referral_note_items?.eye_problem_data?.length > 0 ? referral_note_items?.eye_problem_data : [],
                systemic_illness_data: referral_note_items?.systemic_illness_data?.length > 0 ? referral_note_items?.systemic_illness_data : [],
                surgery_data: referral_note_items?.surgery_data?.length > 0 ? referral_note_items?.surgery_data : [],
            })
        }
    }

    postReferralData = (name) => {
        let states = this.state;
        try {
            let data = {
                // eye_problem_name: states.is_add_eye_pbrlm ? name : "",
                solution_name: "",
                // surgery_name: states.is_add_surgery ? name : "",
                // systemic_illness_name: states.is_add_illness ? name : ""
            }
            if(states.is_add_eye_pbrlm){
                data['eye_problem_name'] = name
            }else if(states.is_add_surgery){
                data['surgery_name'] = name
            }else if(states.is_add_illness){
                data['systemic_illness_name'] = name
            }
            this.LoaderFunction(true);
            RestAPIService.create(data, Serviceurls.DOC_OPT_REFERRAL_GET)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.assignDetails(response?.data?.referral_note_items, true);
                        this.successMessage(response?.data?.message)
                        // this.ClosePopUp();
                        this.LoaderFunction(false);
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.LoaderFunction(false);
                        this.errorMessage(error?.response?.data?.message)
                    } else {
                        this.LoaderFunction(false);
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.LoaderFunction(false);
            this.errorMessage(error.message)
        }
    }

    postProblemData = (problem ,title) => {
        let { eye_problem, surgery,   } = this.state;
        let states = this.state;
        let data = {}
        let value = problem ? problem  : ""
        if(title === "Problem"){
            data = {
                eye_problem_id : eye_problem?.eye_problem_id,
                eye_problem_name: value
            } 
        }
        else if(title === "Surgery"){
            data = {
                surgery_id: surgery?.surgery_id,
                surgery_name: value
            } 
       
        }
        try {
            this.LoaderFunction(true);
            RestAPIService.create(data, Serviceurls.DOC_OPT_REFERRAL_GET)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.assignDetails(response?.data?.referral_note_items, true, title);
                        this.successMessage(response?.data?.message)
                        // this.ClosePopUp();
                        this.LoaderFunction(false);
                        // this.setState({eye_problem : {},surgery :{}, selectedEyeItem: {}, selectedSurItem: {}})
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.LoaderFunction(false);
                        this.errorMessage(error?.response?.data?.message)
                    } else {
                        this.LoaderFunction(false);
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.LoaderFunction(false);
            this.errorMessage(error.message)
        }
    }



    postDoctorData = () => {
        let { doctor_details } = this.state;
        try {
            let isValid = this.CheckAllFields();
            let msg = "";
            if (doctor_details.mobile_number && doctor_details.mobile_number.length !== 10) {
                msg = "Mobile Number must be 10 Digits"
            } else if (doctor_details.email && !CommonValidation.emailValidation(doctor_details.email)) {
                msg = "Invalid Email ID"
            }
            if (isValid && msg === "") {
                this.LoaderFunction("isDoctorLoad", true);
                RestAPIService.create(doctor_details, Serviceurls.DOC_REFERRAL_DOCTOR_OPT)
                    .then((response) => {
                        if (response?.data?.status === 'success') {
                            this.setState({
                                doctorData: response?.data?.doctor_profile?.length > 0 ? response.data?.doctor_profile : []
                            })
                            this.successMessage(response?.data?.message)
                            this.closeDoctorPopup();
                            this.LoaderFunction("isDoctorLoad", false);
                        }
                    }).catch((error) => {
                        if (error?.response?.data?.message) {
                            this.LoaderFunction("isDoctorLoad", false);
                            this.errorMessage(error?.response?.data?.message)
                        } else {
                            this.LoaderFunction("isDoctorLoad", false);
                            this.errorMessage(error.message)
                        }
                    })
            } else {
                this.errorMessage(msg)
            }
        } catch (error) {
            this.LoaderFunction("isDoctorLoad", false);
            this.errorMessage(error.message)
        }
    }

    CheckAllRefferalFields = () => {
        let { doctor_details, eye_problem, surgery } = this.state;
        if (doctor_details.id !== "" && eye_problem?.eye_problem_id && surgery?.surgery_id) {
            return true;
        }
        return false;
    }

    handleReferralSave = () => {
        let { doctor_details, eye_problem, surgery, patientId, refferalText, dynamicValues } = this.state;
        // const { blocks } = JSON.parse(refferalText);
        // let DocNotes = `Dear Doctor ${dynamicValues?.doctor_details?.doctor_name},\n\nThis is with reference To ${dynamicValues?.patientName}, ${dynamicValues?.uhid} ${dynamicValues?.age} has diagnosed with ${dynamicValues?.eye_problem}. We noticed that He / She needs ${dynamicValues?.surgery} surgery to be undergone. Kindly Him / Her evaluate regarding the same.\n\nRegards,\n${dynamicValues?.clinic_doctor}`
        let DocNotes = this.state.doctor_content
        try {
            // let isValid = this.CheckAllRefferalFields();
            // if (isValid) {
            let data = {
                doctor_id: "",
                doctor_notes: DocNotes,
                eye_problem_id: eye_problem?.eye_problem_id,
                patient_id: patientId,
                referral_doctor_id: doctor_details?.id,
                solution_id: null,
                surgery_id: surgery?.surgery_id,
            }
            this.LoaderFunction("isLoader", true);
            RestAPIService.create(data, Serviceurls.DOC_OPT_REFERRAL_POST)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.setState({
                            isSaveSuccess: true,
                            referral_id: response.data.referral_data[response.data.referral_data.length - 1]?.referral_id,
                            refferalText: JSON.stringify(defaultTxt),
                            isDoctorContentNew: false,
                            selectedItem: null,
                            selectedEyeItem: null,
                            selectedSurItem: null,
                        }, () => {
                            this.getDoctorTemplate()
                        })
                        // this.handleReferralClr()
                        this.successMessage(response?.data?.message)
                        this.LoaderFunction("isLoader", false);
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.LoaderFunction("isLoader", false);
                        this.errorMessage(error?.response?.data?.message)
                    } else {
                        this.LoaderFunction("isLoader", false);
                        this.errorMessage(error.message)
                    }
                })
            // } else {
            //     this.errorMessage("Select All Fields")
            // }
        } catch (error) {
            this.LoaderFunction("isDoctorLoad", false);
            this.errorMessage(error.message)
        }
    }

    handleReferralPrint = () => {
        try {
            RestAPIService.PrintPDF(`${Serviceurls.DOC_OPT_REFERRAL_POST}?referral_id=${this.state?.referral_id}&export_type=pdf`).
                then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    this.setState({ disableBtn: false })
                    this.getDoctorTemplate()
                }).catch((error) => {
                    if (error.response?.data?.message) {
                        this.errorMessage(error.response?.data?.message);
                    } else {
                        this.errorMessage(error.message);
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    setEmpty = () => {
        this.setState({
            doctor_content: `Dear Dr ${this.state.doctor_details?.doctor_name},\n\nThis is with reference To  ${this.state?.patientDetails?.first_name} ${this.state?.patientDetails?.last_name ? this.state?.patientDetails?.last_name : ""}, ${`(${this.state?.patientDetails?.patient_account_number})`} ${this.state?.patientDetails?.patient_age_str} has diagnosed with <b>${(Object.keys(this.state?.eye_problem).length > 0 ? this.state?.eye_problem?.eye_problem_name : "_____")}</b>. We noticed that ${this.state.patientDetails.gender ? this.state.patientDetails.gender === 'm' ? "He" : "She" : "He / She"} needs <b>${Object.keys(this.state?.surgery).length > 0 ? this.state?.surgery?.surgery_name : "_____"}</b> to be undergone. Kindly evaluate ${this.state.patientDetails.gender ? this.state.patientDetails.gender == "m" ? "Him" : "Her" : "Him / Her"} regarding the same.\n\nRegards,\nDr ${this.state?.DrName}`
        }, () => {
            if (this.boxRef.current) {
                this.boxRef.current.innerHTML = this.state.doctor_content;
            }
        })
    }
    

    handleChipClk = (stateKey, item) => {
        let states = this.state;
        let { dynamicValues } = this.state;
        let value = "";
        if (stateKey === "eye_problem") {
            value = item?.eye_problem_name ? item?.eye_problem_name : ""
        } else if (stateKey === "systemic_illness") {
            value = item?.systemic_illness_name ? item?.systemic_illness_name : ""
        } else if (stateKey === "surgery") {
            value = item?.surgery_name ? item?.surgery_name : ""
        } else {
            value = item
        }
        if (stateKey === "doctor_details") {
            item["clinics_city"] = this.state.patientDetails.clinics_city || '';
        }
        dynamicValues[stateKey] = value;
        states[stateKey] = item && JSON.parse(JSON.stringify(item));
        // Prepare the map for placeholders
        const doctor_content_map = {
            doctor_name: states.doctor_details?.doctor_name || '',
            patient_name: `${states?.patientDetails?.first_name} ${states?.patientDetails?.last_name || ""}`,
            patient_account: states?.patientDetails?.patient_account_number || '',
            patient_age: states?.patientDetails?.patient_age_str || '',
            eye_problem: `<b>${Object.keys(states?.eye_problem).length > 0 ? states?.eye_problem?.eye_problem_name : '_____'}</b>`,
            gender_pronoun: states.patientDetails.gender === 'm' ? 'He' : states.patientDetails.gender === 'f' ? 'She' : 'He / She',
            surgery_name: `<b>${Object.keys(states?.surgery).length > 0 ? states?.surgery?.surgery_name : '_____'}</b>`,
            gender_object: states.patientDetails.gender === 'm' ? 'Him' : states.patientDetails.gender === 'f' ? 'Her' : 'Him / Her',
            signed_doctor: states?.DrName || ''
        };
        // Replace only placeholders in the current content
        let updatedContent = this.state.doctor_content;
        Object.keys(doctor_content_map).forEach(key => {
            const regex = new RegExp(`{{\\s*${key}\\s*}}`, 'g');
            updatedContent = updatedContent.replace(regex, doctor_content_map[key]);
        });
        // Also update plain text fallback if user never used template
        // (replace only the dynamic values, not the whole content)
        // If no placeholders, try to replace the values in the default text
        if (!/\{\{.*\}\}/.test(this.state.doctor_content)) {
            // fallback: replace known values in the text
            updatedContent = updatedContent
                .replace(/Dear Dr [^,]*,/, `Dear Dr ${doctor_content_map.doctor_name},`)
                .replace(/has diagnosed with [^\.]*\./, `has diagnosed with ${doctor_content_map.eye_problem}.`)
                .replace(/needs .* to be undergone\./, `needs ${doctor_content_map.surgery_name} to be undergone.`)
                .replace(/Kindly evaluate [^ ]* regarding the same\./, `Kindly evaluate ${doctor_content_map.gender_object} regarding the same.`)
                .replace(/Regards,\nDr .*/, `Regards,\nDr ${doctor_content_map.signed_doctor}`);
        }
        this.setState({
            states,
            doctor_content: updatedContent
        }, () => {
            if (this.boxRef.current) {
                this.boxRef.current.innerHTML = updatedContent;
            }
        });
    }

    handleAdd = (stateKey) => {
        let states = this.state;
        states[stateKey] = true;
        this.setState({ states })
        this.setState({
            doctor_content: `Dear Dr ${states.doctor_details?.doctor_name},\n\nThis is with reference To  ${this.state?.patientDetails?.first_name} ${this.state?.patientDetails?.last_name ? this.state?.patientDetails?.last_name : ""}, ${`(${this.state?.patientDetails?.patient_account_number})`} ${this.state?.patientDetails?.patient_age_str} has diagnosed with <b>${(Object.keys(this.state?.eye_problem).length > 0 ? this.state?.eye_problem?.eye_problem_name : "_____")}</b>. We noticed that ${this.state.patientDetails.gender ? this.state.patientDetails.gender === 'm' ? "He" : "She" : "He / She"} needs <b>${Object.keys(this.state?.surgery).length > 0 ? this.state?.surgery?.surgery_name : "_____"}</b> to be undergone. Kindly evaluate ${this.state.patientDetails.gender ? this.state.patientDetails.gender == "m" ? "Him" : "Her" : "Him / Her"} regarding the same.\n\nRegards,\nDr ${this.state?.DrName}`
        }, () => {
            if (this.boxRef.current) {
                this.boxRef.current.innerHTML = this.state.doctor_content;
            }
        })
    }

    updateEditorContent = (values) => {
        const { refferalText } = this.state;
        let DefaultTxt = JSON.parse(refferalText);
        const { blocks } = DefaultTxt;
        let newText = blocks[0].text;

        Object.keys(values).forEach((key) => {
            newText = newText.replace(`[${key}]`, (values[key] ? values[key] : `[${key}]`));
        });
        DefaultTxt.blocks[0].text = newText;
        this.setState({
            refferalText: JSON.stringify(DefaultTxt),
            dynamicValues: { ...values },
        });
    };

    deleteDocChipDatas() {
         try {
           RestAPIService.delete(Serviceurls.DOC_REFERRAL_DOCTOR_OPT, {id : this.state.deleteItem?.id || ""})
             .then((response) => {
               if (response.data.status === "success") {
                 this.getDoctorListData()
               } else {
                 this.errorMessage(response?.data?.message)
               }
             }).catch(error => {
               this.errorMessage(error?.message)
             })
         }
         catch (e) {
           this.errorMessage(e?.message)
         }
       }

       deleteOtherChipData() {
        try {
            let states = this.state
            let problemData = states.deleteItem?.eye_problem_id ?  states.deleteItem?.eye_problem_id : ""
            let surData = states.deleteItem?.surgery_id ?  states.deleteItem?.surgery_id : ""
          RestAPIService.delete(Serviceurls.DOC_OPT_REFERRAL_GET + "?eye_problem_id=" + problemData + "&surgery_id=" + surData).
            then((response) => {
              if (response.data.status === "success") {
                this.getReferralNotesData()
              } else {
                this.errorMessage(response?.data?.message)
              }
            }).catch(error => {
              this.errorMessage(error?.message)
            })
        }
        catch (e) {
          this.errorMessage(e?.message)
        }
      }
    // handleAdd = (stateKey) => {
    //     let states = this.state;
    //     states[stateKey] = true;
    //     this.setState({ states })
    // }

    ClosePopUp = () => {
        this.setState({
            is_add_doctor: false,
            is_add_eye_pbrlm: false,
            is_add_illness: false,
            is_add_surgery: false,
            selectedItem: null,
            selectedEyeItem: null,
            selectedSurItem: null,
        })
    }

    handleReferralClr = () => {
        this.setState({
            eye_problem: {},
            eye_type: "",
            systemic_illness: {},
            surgery: {},
        })
        this.ClosePopUp();
    }

    renderChip = (title, List, stateKey, showKey, idKey, addKey) => {
        let states = this.state;
        return (
            <Box component={'div'} borderBottom={'1px solid lightgray'} sx={{ padding: "0.6vw", marginTop: "0.3vw", minHeight: stateKey === "eye_type" ? "" : "18vh" }}>
                <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText} pl={"0.5vw"}>{title}</Typography>
                <Box component={'div'} display={'flex'} flexWrap={'wrap'} marginY={"0.625vw"}>
                    {states.isDoctorLoad ? <CircularProgress size={'small'} color='primary' /> :
                        List?.length > 0 ? List?.map((item) => {
                            return (
                                <Chip
                                    emed_tid={`referral_notes_${stateKey}_chip_${item[idKey]}`}
                                    className={`eMed_chip ${title === "Eye Type" ? (item === states[stateKey] ? 'eMed_Chip_OnClick' : "eMed_Chip_Border") : (states[stateKey][idKey] === item[idKey] ? 'eMed_Chip_OnClick' : "eMed_Chip_Border")}`}
                                    size="small"
                                    label={showKey ? (title === "Doctor / Business" ?  item[showKey] ? `Dr ${item[showKey]}`: item["clinic_name"] : item[showKey]) : item}
                                    disabled={!this.state.isDoctorContentNew}
                                    key={item[idKey]}
                                    variant={title === "Eye Type" ? (item === states[stateKey] ? 'contained' : "outlined") : (states[stateKey][idKey] === item[idKey] ? 'contained' : "outlined")}
                                    onDelete={(title === "Eye Type" || states[stateKey][idKey] === item[idKey]) ? null : () => { 
                                        this.setState({ deleteItem: item }, () => {
                                            if (title === 'Doctor / Business') {
                                                this.deleteDocChipDatas();
                                            } else {
                                                this.deleteOtherChipData();
                                            }
                                        });
                                    }}
                                    onClick={() => {
                                        if (item === states[stateKey]) {
                                            if (title === 'Doctor / Business') {
                                                let doctor_details = {
                                                    id: "",
                                                    doctor_name: "",
                                                    qualifications: "",
                                                    designation: "",
                                                    clinic_name: "",
                                                    city_name: "",
                                                    country: "",
                                                    mobile_number: "",
                                                    email: "",
                                                    clinics_city:''
                                                }
                                                states[stateKey] = doctor_details
                                                this.setState({ selectedItem: null, states })
                                             }
                                            //  else if(title === 'Eye Problem') {
                                            //     this.setState({ selectedEyeItem: null, eye_problem: {} }, ()=>{this.setEmpty()})
                                            // }
                                            else if(title === 'Problem'){
                                                this.setState({ selectedEyeItem: null,eye_problem: {} }, ()=>{this.setEmpty()})
                                            }else if(title === 'Surgery'){
                                                this.setState({ selectedSurItem: null, surgery: {} }, ()=>{this.setEmpty()})
                                            }
                                        } else {
                                            if (title === 'Doctor / Business') {
                                                this.setState({ selectedItem: item }, () => this.handleChipClk(stateKey, item))
                                            } 
                                            // else if(title === 'Eye Problem') {
                                            //     this.setState({ selectedEyeItem: item }, () => this.handleChipClk(stateKey, item))
                                            // }
                                            else if(title === 'Problem'){
                                                this.setState({ selectedEyeItem: item }, () => this.handleChipClk(stateKey, item))
                                            }else if(title === 'Surgery'){
                                                this.setState({ selectedSurItem: item }, () => this.handleChipClk(stateKey, item))
                                            }else{
                                                this.handleChipClk(stateKey, item)
                                            }
                                        }

                                        // this.handleChipClk(stateKey, item)
                                    }}
                                />
                            )
                        }) : <p style={{ margin: "0.4vw auto", fontSize: "0.85vw", color: Colors.SecondaryText }}>{"No data found..."}</p>
                    }
                </Box>
                {stateKey === "eye_type" ? null : <Button
                    disabled={states.isLoader || !this.state.isDoctorContentNew ||  getCachevalue('DoctorUserChanged') === 'true'}
                    variant='contained'
                    size={"small"}
                    id="eMed_recPayment_btn"
                    sx={{ marginTop: "0.625vw", marginLeft: "0.5vw" }}
                    onClick={() => {this.handleAdd(addKey)}}
                    emed_tid={`doc_referral_${addKey}_add_btn`}
                >{(this.state.selectedItem?.id && states[stateKey]["id"] === this.state.selectedItem?.id) ? 'Edit' :
                   (this.state.selectedEyeItem?.eye_problem_id && states[stateKey]["eye_problem_id"] === this.state.selectedEyeItem?.eye_problem_id) ? 'Edit' :
                   (this.state.selectedSurItem?.surgery_id && states[stateKey]["surgery_id"] === this.state.selectedSurItem?.surgery_id) ? 'Edit' :
                  "Add"}</Button>}
            </Box>
        )
    }

    handleChange = (e) => {
        let { name, value } = e.target;
        value = value.trimStart();
        let { doctor_details } = this.state;
        let isValid = false;

        switch (name) {
            case "doctor_name":
            case "city_name":
            case "country":
                isValid = CommonValidation.alphabetOnly(value);
                if (value === "" || isValid && value) {
                    doctor_details[name] = value;
                }
                break;
            case "mobile_number":
                isValid = CommonValidation.numberOnly(value)
                if (value === "" || isValid && value.length <= 10) {
                    doctor_details["mobile_number"] = value;
                }
                break;
            default:
                doctor_details[name] = value;
                break;
        }
        this.setState({ doctor_details })
    }

    renderTextbox = (label, stateKey, mandatory = false) => {
        let { t } = this.props;
        let { doctor_details } = this.state;
        const emedTidMap = {
            'doctor_name': 'doc_referral_doctor_name_input',
            'qualifications': 'doc_referral_qualifications_input',
            'designation': 'doc_referral_designation_input',
            'clinic_name': 'doc_referral_clinic_name_input',
            'city_name': 'doc_referral_city_name_input',
            'country': 'doc_referral_country_input',
            'mobile_number': 'doc_referral_mobile_number_input',
            'email': 'doc_referral_email_input'
        }
        return (
            <TextField
                label={t(label)}
                required={mandatory}
                sx={{ width: "16vw", margin: "0.6vw" }}
                size="small"
                autoComplete="off"
                name={stateKey}
                value={doctor_details[stateKey] ? doctor_details[stateKey] : ""}
                onChange={this.handleChange}
                emed_tid={emedTidMap[stateKey]}
            />)
    }

    handleclear = () => {
        let states = this.state
        states["doctor_details"] = {
            id: "",
            doctor_name: "",
            qualifications: "",
            designation: "",
            clinic_name: "",
            city_name: "",
            country: "",
            mobile_number: "",
            email: "",
            clinics_city:''
        }
        states["eye_problem"] = {}
        states["eye_type"] = ""
        states["systemic_illness"] = ""
        states["surgery"] = ""
        states.selectedSurItem = {}
        states.selectedEyeItem ={}
        this.setState({
            states
        }, () => {
            this.setState({
                doctor_content: `Dear Dr ${this.state.doctor_details?.doctor_name},\n\nThis is with reference To  ${this.state?.patientDetails?.first_name} ${this.state?.patientDetails?.last_name ? this.state?.patientDetails?.last_name : ""}, ${`(${this.state?.patientDetails?.patient_account_number})`} ${this.state?.patientDetails?.patient_age_str} has diagnosed with <b>${(Object.keys(this.state?.eye_problem).length > 0 ? this.state?.eye_problem?.eye_problem_name : "_____")}</b>. We noticed that ${this.state.patientDetails.gender ? this.state.patientDetails.gender === 'm' ? "He" : "She" : "He / She"} needs <b>${Object.keys(this.state?.surgery).length > 0 ? this.state?.surgery?.surgery_name : "_____"}</b> to be undergone. Kindly evaluate ${this.state.patientDetails.gender ? this.state.patientDetails.gender == "m" ? "Him" : "Her" : "Him / Her"} regarding the same.\n\nRegards,\nDr ${this.state?.DrName}`,
                isDoctorContentNew: true,
                referral_id: ""
            }, () => {
                if (this.boxRef.current) {
                    this.boxRef.current.innerHTML = this.state.doctor_content;
                }
            })
        })
    }

    closeDoctorPopup = () => {
        this.setState({
            is_add_doctor: false,
            doctor_details: {
                id: "",
                doctor_name: "",
                qualifications: "",
                designation: "",
                clinic_name: "",
                city_name: "",
                country: "",
                mobile_number: "",
                email: "",
                clinics_city: "",
            }
        })
    }

    CheckAllFields = () => {
        let { doctor_name, clinic_name } = this.state.doctor_details;
        if (!(doctor_name || clinic_name)) {
            return false
        }
        return true
    }

    renderDoctorPopUp = () => {
        return (
            <Box>
                <Stack direction="row" justifyContent={"space-between"} alignItems={"center"}>
                    {this.renderTextbox("Doctor Name", "doctor_name", true)}
                    {this.renderTextbox("Qualification", "qualifications")}
                </Stack>
                <Stack direction="row" justifyContent={"space-between"} alignItems={"center"}>
                    {this.renderTextbox("Designation", "designation")}
                    {this.renderTextbox("Hospital / Clinic / Business", "clinic_name", true)}
                </Stack>
                <Stack direction="row" justifyContent={"space-between"} alignItems={"center"}>
                    {this.renderTextbox("City", "city_name")}
                    {this.renderTextbox("Country", "country")}
                </Stack>
                <Stack direction="row" justifyContent={"space-between"} alignItems={"center"}>
                    {this.renderTextbox("Mobile Number", "mobile_number")}
                    {this.renderTextbox("Email", "email")}
                </Stack>
            </Box>
        )
    }

    getTempData = () => {
        try {
            if (this.state.isDoctorContentNew) {
                RestAPIService.getAll(Serviceurls.ADD_REFERRAL_NOTES_TEMP)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            const templateList = response?.data?.data || [];
                            const defaultTemplate = templateList.find(t => t.default_template === true);
                            const doctor_content = {
                                doctor_name: this.state.doctor_details?.doctor_name || '',
                                patient_name: `${this.state?.patientDetails?.first_name} ${this.state?.patientDetails?.last_name || ""}`,
                                patient_account: this.state?.patientDetails?.patient_account_number || '',
                                patient_age: this.state?.patientDetails?.patient_age_str || '',
                                eye_problem: Object.keys(this.state?.eye_problem).length > 0 ? `<b>${this.state?.eye_problem?.eye_problem_name}</b>` : '<b>_____</b>',
                                gender_pronoun: this.state.patientDetails.gender === 'm' ? 'He' : this.state.patientDetails.gender === 'f' ? 'She' : 'He / She',
                                surgery_name: Object.keys(this.state?.surgery).length > 0 ? `<b>${this.state?.surgery?.surgery_name}</b>` : '<b>_____</b>',
                                gender_object: this.state.patientDetails.gender === 'm' ? 'Him' : this.state.patientDetails.gender === 'f' ? 'Her' : 'Him / Her',
                                signed_doctor: this.state?.DrName || ''
                            };

                            const finalContent = this.replacePlaceholders(defaultTemplate?.referral_notes || '', doctor_content);
                            this.setState({
                                templateList,
                                doctor_content: finalContent ? finalContent : this.state.doctor_content,
                                tempContent: finalContent ? finalContent : this.state.tempContent,
                                selectTemplate: defaultTemplate ? defaultTemplate.id : '',
                                edittempName: defaultTemplate?.id ? true : false,
                            }, () => {
                                if (this.boxRef.current) {
                                    this.boxRef.current.innerHTML = this.state.doctor_content;
                                }
                            });
                        }
                    })
                    .catch((e) => {
                        this.errorMessage(e.response.data.message || e.message)
                    })
            }
        } catch (e) {
            this.errorMessage(e.message)
        }
    }

    addTempLayout = () => {
        try {
            let states = this.state
            let data = {
                "template_name": states.addLayoutName || '',
                "referral_notes": states.tempContent || '',
                "default_template": states.isDefault
            }
            if(states.selectedID){
                data['template_id'] = states.selectedID
             }
            
            let url = states.selectedID ? RestAPIService.updateWithOutId(data, Serviceurls.ADD_REFERRAL_NOTES_TEMP) : RestAPIService.create(data, Serviceurls.ADD_REFERRAL_NOTES_TEMP)

            url.then((response) => {
                if(response.data.status === 'success'){
                    this.getTempData()
                    this.setState({
                        addLayoutName: '',
                        isTempAdd: false,
                        selectedID: null,
                        tempContent: '',
                    })
                    this.successMessage(response.data.message)
                }
            })
            .catch((e)=>{
                this.errorMessage(e.response.data.message || e.message)
            })
        }catch(e){
            this.errorMessage(e.message)
        }
    }

    deleteTemp = () => {
        try {
            let states = this.state
            let data = {
                "template_id": states.selecDelID || null,
            }

            RestAPIService.delete(Serviceurls.ADD_REFERRAL_NOTES_TEMP, data)
            .then((response) => {
                if(response.data.status === 'success'){
                    this.getTempData()
                    this.getReferralNotesData()
                    this.getDoctorTemplate()
                    this.setState({
                        deleteTemp: false,
                        selecDelID: null,
                        selectTemplate: ''
                    })
                    this.successMessage(response.data.message)
                }
            })
            .catch((e)=>{
                this.errorMessage(e.response.data.message || e.message)
            })
        }catch(e){
            this.errorMessage(e.message)
        }
    }

    extractPlaceholders = (str) => {
        const matches = str.match(/{{\s*[\w\.]+\s*}}/g) || [];
        const placeholders = {};
        matches.forEach(match => {
            const cleanKey = match.replace(/{{\s*|\s*}}/g, '');
            placeholders[match] = cleanKey;
        });
        return Object.keys(placeholders); // return full {{...}} form
    }

    restoreTemplate = (userText, commonTemplate, doctorContent) => {
        const placeholders = this.extractPlaceholders(commonTemplate);
        let restored = userText;

        // Replace first and second "_____" with specific placeholders
        let dashCount = 0;
        restored = restored.replace(/_{3,}/g, () => {

            dashCount++;
            if (dashCount === 1) return '{{eye_problem}}';
            if (dashCount === 2) return '{{surgery_name}}';
            return '_____';
        });

        // Special case: restore doctor name after "Dear Dr"
        restored = restored.replace(/Dear Dr\s*,/, 'Dear Dr {{doctor_name}},');

        // Replace other known values in the restored template
        placeholders.forEach(placeholder => {
            const key = placeholder.replace(/{{\s*|\s*}}/g, '');
            const value = doctorContent[key];

            if (!value) return;

            const safeValue = value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const regex = new RegExp(safeValue, 'g');
            restored = restored.replace(regex, placeholder);
        });

        return restored;
    }


    renderLayAdd = () => {
        const { t } = this.props
        return (
            <Dialog open={this.state.isTempAdd} >
                <DialogTitle className='eMed_CreditPoP_TitleDiv' sx={{ borderColor: Colors.themeDark }}>
                    <Typography marginLeft={"1vw"}>{t("AddLayName")}</Typography>
                    <Button emed_tid='referral_notes_template_popup_close' onClick={() => { this.setState({ isTempAdd: false, addLayoutName: '' }) }} >
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </DialogTitle>
                <DialogContent sx={{ padding: "2vw" }}>
                    <TextField
                        emed_tid='referral_notes_template_name_textfield'
                        inputProps={{ maxLength: 30 }}
                        sx={{ width: "20vw", marginTop: "2vw" }}
                        size='small'
                        label={t("LayoutName")}
                        value={this.state.addLayoutName}
                        onChange={(event) => {
                            let alphanum = CommonValidation.alphanumValidation(event.target.value);
                            if (alphanum || event.target.value === '') {
                                this.setState({
                                    addLayoutName: event.target.value
                                })
                            }
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' size='small' className='eMed_Filter_Btns' onClick={() => { this.setState({ addLayoutName: '' }) }} emed_tid="doc_referral_template_clear_btn">{t("Clear")}</Button>
                    <Button variant='contained' size='small' className='eMed_Filter_Btns' emed_tid="doc_referral_template_save_btn" onClick={() => {
                        var states = this.state 
                        if (states.addLayoutName !== '') {
                            const def = `Dear Dr {{doctor_name}},\n\nThis is with reference To  {{patient_name}}, ({{patient_account}}) {{patient_age}} has diagnosed with {{eye_problem}}. We noticed that {{gender_pronoun}} needs {{surgery_name}} surgery to be undergone. Kindly evaluate {{gender_object}} regarding the same.\n\nRegards,\nDr {{signed_doctor}}`
                            const doctor_content = {
                                doctor_name: this.state.doctor_details?.doctor_name || '',
                                patient_name: `${this.state?.patientDetails?.first_name} ${this.state?.patientDetails?.last_name || ""}`,
                                patient_account: this.state?.patientDetails?.patient_account_number || '',
                                patient_age: this.state?.patientDetails?.patient_age_str || '',
                                eye_problem: Object.keys(this.state?.eye_problem).length > 0 ? this.state?.eye_problem?.eye_problem_name : '',
                                gender_pronoun: this.state.patientDetails.gender === 'm' ? 'He' : this.state.patientDetails.gender === 'f' ? 'She' : 'He / She',
                                surgery_name: Object.keys(this.state?.surgery).length > 0 ? this.state?.surgery?.surgery_name : '',
                                gender_object: this.state.patientDetails.gender === 'm' ? 'Him' : this.state.patientDetails.gender === 'f' ? 'Her' : 'Him / Her',
                                signed_doctor: this.state?.DrName || ''
                            };

                            const userTypedTemplate = this.state.doctor_content;
                            const restoredTemplate = this.restoreTemplate(userTypedTemplate, def, doctor_content);

                           this.setState({
                            tempContent: restoredTemplate
                           },()=>{
                            this.addTempLayout()
                           })
                        } else {
                            this.errorMessage(t('PALN'));
                        }

                    }}>{this.state.renameLayout ? t("Rename") : t("Add")}</Button>
                </DialogActions>
            </Dialog>
        )
    }

    popClose = () => {
    this.setState({
      deleteTemp: false,
      selecDelID: null
    })
  }

    replacePlaceholders = (template, contentMap) => {
        let result = template;
        Object.keys(contentMap).forEach(key => {
            const regex = new RegExp(`{{\\s*${key}\\s*}}`, 'g');
            result = result.replace(regex, contentMap[key] || '_____');
        });
        return result;
    }

    render() {
        let { t } = this.props;
        let states = this.state;
        let attender = {
            lineOne: "Attender Name",
            lineTwo: `${this.state.patientDetails?.attender_name ? this.state.patientDetails?.attender_name :
                this.state.patientDetails?.caretaker_name ? this.state.patientDetails?.caretaker_name : "-"}`,
            lineFour: 'Contact Number',
            LineFive: `${this.state.patientDetails?.attender_mobile ? this.state.patientDetails?.attender_mobile :
                this.state.patientDetails?.caretaker_mobile ? this.state.patientDetails?.caretaker_mobile : "-"}`
        }
        return (
            <Box component={'div'} sx={{ backgroundColor: Colors.Background }} height={'74vh'} p={'0.5vw'}>
                <Box component={'div'} display={'flex'}>
                    <Box component={'div'} className='doc_header_card' mr={'0.5vw'}>
                        <CommonPatientDetails data={this.state.patientDetails} showDetailed={true} fromDoctor={true} />
                    </Box>
                    {/* <CommonPatientCard details={attender} showDetailed={true} /> */}
                </Box>
                <Box component={'div'} display={'flex'} mt={'0.5vw'} height={'61.5vh'}>
                    <Box component={'div'} flex={0.65} >
                        <Box component={'div'} border={'1px solid lightgray'} height={'5.15vh'} display={'flex'} pl={'0.5vw'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography fontWeight={600}>{"Referral Notes"}</Typography>
                            <FormControl size="small" sx={{ width: '13vw', paddingRight: '0.5vw' }}>
                                <InputLabel id="referral_form">{t('select Template')}</InputLabel>
                                <Select
                                    emed_tid='referral_notes_template_select'
                                    labelId="referral_form"
                                    id="demo-simple"
                                    disabled={!this.state.isDoctorContentNew}
                                    value={this.state.isDoctorContentNew ? states.selectTemplate : ''}
                                    label={t('select Template')}
                                    onChange={(e) => {
                                        const selectedTemplate = states.templateList.find(t => t.id === e.target.value);
                                        const doctor_content = {
                                            doctor_name: this.state.doctor_details?.doctor_name || '',
                                            patient_name: `${this.state?.patientDetails?.first_name} ${this.state?.patientDetails?.last_name || ""}`,
                                            patient_account: this.state?.patientDetails?.patient_account_number || '',
                                            patient_age: this.state?.patientDetails?.patient_age_str || '',
                                            eye_problem: Object.keys(this.state?.eye_problem).length > 0 ? `<b>${this.state?.eye_problem?.eye_problem_name}</b>` : '<b>_____</b>',
                                            gender_pronoun: this.state.patientDetails.gender === 'm' ? 'He' : this.state.patientDetails.gender === 'f' ? 'She' : 'He / She',
                                            surgery_name: Object.keys(this.state?.surgery).length > 0 ? `<b>${this.state?.surgery?.surgery_name}</b>` : '<b>_____</b>',
                                            gender_object: this.state.patientDetails.gender === 'm' ? 'Him' : this.state.patientDetails.gender === 'f' ? 'Her' : 'Him / Her',
                                            signed_doctor: this.state?.DrName || ''
                                            };

                                            const finalContent = this.replacePlaceholders(selectedTemplate?.referral_notes || '', doctor_content);

                                        this.setState({
                                            edittempName: true,
                                            selectTemplate: selectedTemplate.id,
                                            doctor_content: finalContent
                                        }, () => {
                                            if (this.boxRef.current) {
                                                this.boxRef.current.innerHTML = finalContent;
                                            }
                                        });
                                    }}
                                    sx={{ backgroundColor: 'white' }}
                                    MenuProps={MenuProps}
                                >
                                    {states.templateList.length > 0 ? states.templateList.map((item) => (
                                        <MenuItem emed_tid={`referral_notes_template_option_${item.id}`} value={item.id} key={item.id}>
                                            <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} width={'100%'} alignItems={'center'} >
                                                {item.template_name.length > 13 ? <Tooltip title={item.template_name} placement='top'><Typography>{item.template_name.slice(0, 13) + '...'}</Typography></Tooltip> : <Typography>{item.template_name}</Typography>}
                                                {item.default_template && (
                                                    <img src={ImagePaths.DefaultIcon.default} style={{ width: '1.2vw', height: '1.2vw' }} alt='default' />
                                                )}
                                            </Box>
                                        </MenuItem>
                                    )) : <Typography align='center'>{t('NDF')}</Typography>}
                                    <Divider />
                                    {/* Edit/Delete Buttons based on selectedTemplate */}
                                    <List>
                                        {this.state.edittempName && (
                                            <List>
                                                <ListItem disablePadding>
                                                    <ListItemButton onClick={() => {
                                                        const selected = states.templateList.find(t => t.id === states.selectTemplate);
                                                        this.setState({
                                                            isTempAdd: true,
                                                            addLayoutName: selected?.template_name || '',
                                                            selectedID: selected?.id
                                                        });
                                                    }} emed_tid="doc_referral_template_rename_btn">
                                                        <ListItemText primary={"Rename"} />
                                                    </ListItemButton>
                                                </ListItem>
                                                <ListItem disablePadding>
                                                    <ListItemButton onClick={() => {
                                                        this.setState({ deleteTemp: true, selecDelID: states.selectTemplate });
                                                    }} emed_tid="doc_referral_template_delete_btn">
                                                        <ListItemText primary={"Delete"} />
                                                    </ListItemButton>
                                                </ListItem>
                                                <ListItem disablePadding>
                                                    <ListItemButton emed_tid='referral_notes_template_default_button' onClick={() => {
                                                        const selected = states.templateList.find(t => t.id === states.selectTemplate);
                                                        if (selected?.default_template) {
                                                            // Remove Default
                                                            this.setState({
                                                                addLayoutName: selected?.template_name || '',
                                                                tempContent: selected?.referral_notes || '',
                                                                selectedID: selected?.id,
                                                                isDefault: false
                                                            }, () => {
                                                                this.addTempLayout();
                                                            });
                                                        } else {
                                                            // Make as Default
                                                            this.setState({
                                                                addLayoutName: selected?.template_name || '',
                                                                tempContent: selected?.referral_notes || '',
                                                                selectedID: selected?.id,
                                                                isDefault: true
                                                            }, () => {
                                                                this.addTempLayout();
                                                            });
                                                        }
                                                    }}>
                                                        <ListItemText primary={
                                                            (() => {
                                                                const selected = states.templateList.find(t => t.id === states.selectTemplate);
                                                                return selected?.default_template ? 'Remove Default' : 'Make as Default';
                                                            })()
                                                        } />
                                                    </ListItemButton>
                                                </ListItem>
                                            </List>
                                        )}
                                    </List>
                                </Select>

                            </FormControl>
                        </Box>
                        {/* <Box border={'1px solid lightgray'} height={"100%"}>
                            <MUIRichTextEditor
                                controls={["bold", "italic", "underline", "highlight", "undo", "redo"]}
                                inlineToolbar={true}
                                defaultValue={this.state.refferalText}
                            />
                        </Box> */}
                        <Box border={'1px solid lightgray'} height={"25vw"} p={"1vw"}>
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "space-between", height: "10vh" }}>
                                <div>
                                    <div>To</div>
                                    {this.state?.doctor_details?.id != "" ?
                                        <div style={{ marginLeft: "0.65vw" }}>
                                            <div style={{ fontWeight: 'bold' }}>{`${states.doctor_details?.doctor_name} ${states.doctor_details?.qualifications}`}</div>
                                            <div>{`${states.doctor_details?.designation}`}</div>
                                            <div>{`${states.doctor_details?.clinic_name}`}</div>
                                            <div>{`${states.doctor_details?.city_name}`}</div>
                                        </div> : null
                                    }
                                </div>
                                <div>
                                    <div>{`${states.patientDetails?.clinics_city ? states.doctor_details?.clinics_city || "" : ''}`}</div>
                                    <div>{formattedDate}</div>
                                </div>
                            </div>
                            <div style={{ fontSize: "1.1vw", fontWeight: "600", textAlign: "center", padding: "1vw" }}>{`Greetings from ${this.state?.DrName}`}</div>
                            {/* <div>{`Dear Dr ${states.doctor_details?.doctor_name},`}</div> */}
                            <div style={{ display: "flex", flexDirection: "row", marginTop: "0.75vw", marginLeft: "0.8vw" }}>
                                {/* <div>{`This is with reference To ${states?.patientDetails?.first_name} ${states?.patientDetails?.last_name ? states?.patientDetails?.last_name : ""}, ${`(${states?.patientDetails?.patient_account_number})`} ${states?.patientDetails?.patient_age_str} has diagnosed with ${(Object.keys(states?.eye_problem).length > 0 ? states?.eye_problem?.eye_problem_name : "_____")} . We noticed that He / She needs ${Object.keys(states?.surgery).length > 0 ? states?.surgery?.surgery_name : "_____"} to be undergone. Kindly  Him / Her evaluate regarding the same.`}</div> */}
                                <Box
                                    ref={this.boxRef}
                                    contentEditable
                                    suppressContentEditableWarning={true}
                                    sx={{
                                        width: "100%",
                                        overflowY: "auto",
                                        fontSize: "1rem",           // 16px
                                        lineHeight: "1.4375em",     // ~23px
                                        minHeight: "20vh",
                                        height: `${10 * 23}px`,      // rows * line-height ≈ 230px
                                        whiteSpace: "pre-wrap",
                                        outline: "none",
                                        fontWeight: 400,
                                    }}
                                    spellCheck="false"
                                    onInput={() => {
                                        if (this.boxRef.current) {
                                            this.setState({ doctor_content: this.boxRef.current.innerHTML });
                                        }
                                    }}
                                    onPaste={(e) => {
                                        e.preventDefault();
                                        const text = e.clipboardData.getData("text/plain");

                                        const sel = window.getSelection();
                                        if (!sel.rangeCount) return;
                                        const range = sel.getRangeAt(0);
                                        range.deleteContents();
                                        range.insertNode(document.createTextNode(text));

                                        // Move caret to end of inserted text
                                        range.collapse(false);
                                        sel.removeAllRanges();
                                        sel.addRange(range);

                                        if (this.boxRef.current) {
                                            this.setState({ doctor_content: this.boxRef.current.innerHTML });
                                        }
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault(); // stop default <div>/<br>

                                            const sel = window.getSelection();
                                            if (!sel.rangeCount) return;

                                            const range = sel.getRangeAt(0);

                                            // Insert newline at caret
                                            const textNode = document.createTextNode("\n");
                                            range.insertNode(textNode);

                                            // Move cursor after the newline
                                            range.setStartAfter(textNode);
                                            range.setEndAfter(textNode);

                                            sel.removeAllRanges();
                                            sel.addRange(range);

                                            // Ensure caret stays visible
                                            setTimeout(() => {
                                                if (this.boxRef.current) {
                                                    this.boxRef.current.scrollTop = this.boxRef.current.scrollHeight;
                                                }
                                            }, 0);
                                        }
                                    }}
                                />
                            </div>
                            <div style={{ marginTop: "1.25vw" }}>
                                {/* <div>Regards,</div>
                                <div>{`Dr ${this.state?.DrName}`}</div> */}
                            </div>
                        </Box>
                        <Box display={'flex'} justifyContent={'center'} mt={'.2vw'}>
                            <Button emed_tid='referral_notes_add_template_button' size='small' variant='contained' sx={{ textTransform: 'capitalize' }} disabled={!this.state.isDoctorContentNew || getCachevalue('DoctorUserChanged') === 'true' } onClick={() => {this.setState({
                                isTempAdd: true
                            })}}>{'Add Template'}</Button>
                        </Box>
                    </Box>
                    <Box component={'div'} flex={0.35} border={'1px solid lightgray'}>
                        <Box component={'div'} height={'5.15vh'} display={'flex'} pl={'0.5vw'} alignItems={'center'}>
                            <Typography fontWeight={600}>{"Referral Doctor"}</Typography>
                        </Box>
                        <Box sx={{ backgroundColor: Colors.white, height: "50.17vh", overflowY: "auto" }}>
                            {this.renderChip("Doctor / Business", states.doctorData, "doctor_details", "doctor_name", "id", "is_add_doctor")}
                            {this.renderChip("Problem", states.eye_problem_data, "eye_problem", "eye_problem_name", "eye_problem_id", "is_add_eye_pbrlm")}
                            {this.renderChip("Surgery", states.surgery_data, "surgery", "surgery_name", "surgery_id", "is_add_surgery")}
                        </Box>
                        <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'} height={'6.18vh'}>
                            {this.state.isDoctorContentNew ? null : <Button
                                emed_tid='referral_notes_reset_button'
                                variant='outlined'
                                sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize', mr: '1vw' }}
                                onClick={() => { this.handleclear() }}
                            >{"Reset"}</Button>}
                            <Button
                                emed_tid='referral_notes_save_button'
                                sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize', mr: '1vw' }}
                                variant='contained' /*disabled={!this.CheckAllRefferalFields()}*/
                                
                                disabled={this.state.disableBtn || getCachevalue('DoctorUserChanged') === 'true'}
                                onClick={() => this.setState({ disableBtn: true }, () => this.handleReferralSave())}
                            >{"Save"}</Button>
                            <Button
                                emed_tid='referral_notes_print_button'
                                sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize' }}
                                variant='contained' disabled={!this.state?.referral_id || this.state.disableBtn}
                                onClick={() => this.setState({ disableBtn: true }, () => this.handleReferralPrint())}
                            >{"Print"}</Button>
                        </Box>
                    </Box>
                </Box>

                {this.state.is_add_doctor ?
                    <CommonPopUp
                        width={"35vw"}
                        backgroundColor={Colors.white} justifyRight={true}
                        popUpClose={this.closeDoctorPopup} title={t("Add New Doctor")}
                        component={this.renderDoctorPopUp} buttonOne={t("Cancel")}
                        buttonOneAction={this.closeDoctorPopup} buttonTwo={t("Save")}
                        buttonTwoAction={this.postDoctorData} disableBtn2={!this.CheckAllFields()}
                    />
                    : null
                }

                {
                    this.state.is_add_eye_pbrlm ?
                        <AddNewListItemPop
                            title={"Problem"}
                            key={"is_add_eye_pbrlm"}
                            problemData ={this.state.selectedEyeItem?.eye_problem_name}
                            sendproblemData ={this.postProblemData.bind(this)}
                            ClosePopUp={this.ClosePopUp.bind(this)}
                            sendNewData={this.postReferralData.bind(this)} />
                        : null
                }

                {/* {
                    this.state.is_add_illness ?
                        <AddNewListItemPop
                            title={"Systemic Illness"}
                            key={"is_add_illness"}
                            problemData ={this.state.selectedEyeItem?.eye_problem_name}
                            sendproblemData ={this.postProblemData.bind(this)}
                            ClosePopUp={this.ClosePopUp.bind(this)}
                            sendNewData={this.postReferralData.bind(this)} />
                        : null
                } */}
                {
                    this.state.is_add_surgery ?
                        <AddNewListItemPop
                            title={"Surgery"}
                            key={"is_add_surgery"}
                            problemData ={this.state.selectedSurItem?.surgery_name}
                            sendproblemData ={this.postProblemData.bind(this)}
                            ClosePopUp={this.ClosePopUp.bind(this)}
                            sendNewData={this.postReferralData.bind(this)} />
                        : null
                }

                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}

                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                <Loader loaderOpen={this.state.isLoader} />
                {this.state.isTempAdd ? this.renderLayAdd() : null}
                {this.state.deleteTemp ? <ConfirmPopup
                    cnfTitle={t('Confirmation')}
                    cnfContent={t('Are you sure, Do you want Delete the Template')}
                    cnfAlertPopupClose={this.popClose.bind(this)}
                    cnfData={this.deleteTemp.bind(this)}
                /> : null}
            </Box>
        )
    }
}
export default withTranslation()(DocRefferalNotesCommon);
